var render = function () {
  var _vm$preorderSetting$t;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "PreorderSettingList",
      "extra-items": _vm.isEditing ? [{
        text: (_vm$preorderSetting$t = _vm.preorderSetting.title) !== null && _vm$preorderSetting$t !== void 0 ? _vm$preorderSetting$t : ''
      }, '編輯預購單設定檔'] : ['新增預購單設定檔']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('li', {
    class: {
      active: _vm.step == '',
      done: _vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_ADVANCE]) ? _c('li', {
    class: {
      active: _vm.step == '#fields',
      done: _vm.preorderSetting.config.fields && _vm.preorderSetting.config.fields.length > 0,
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#fields');
      }
    }
  }, [_c('a', [_vm._v("資料集欄位")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('li', {
    class: {
      active: _vm.step == '#product-setting',
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#product-setting');
      }
    }
  }, [_c('a', [_vm._v("商品設定")])]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('li', {
    class: {
      active: _vm.step == '#welcome',
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#welcome');
      }
    }
  }, [_c('a', [_vm._v("歡迎頁")])]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('li', {
    class: {
      active: _vm.step == '#confirm',
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#confirm');
      }
    }
  }, [_c('a', [_vm._v("確認頁")])]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_MODIFY]) ? _c('li', {
    class: {
      active: _vm.step == '#finish',
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#finish');
      }
    }
  }, [_c('a', [_vm._v("完成頁")])]) : _vm._e(), _vm.checkPermission([_vm.consts.PREORDER_SETTING_ADVANCE]) ? _c('li', {
    class: {
      active: _vm.step == '#advance-setting',
      disabled: !_vm.preorderSetting.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#advance-setting');
      }
    }
  }, [_c('a', [_vm._v("進階設定")])]) : _vm._e()])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEditing ? '編輯預購單設定檔' : '新增預購單設定檔'))]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預購單活動名稱"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.preorderSetting.title.$error ? false : null
    },
    model: {
      value: _vm.preorderSetting.title,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting, "title", $$v);
      },
      expression: "preorderSetting.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.preorderSetting.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間",
      "label-for": "start_at"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.start_at.date.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "date", $$v);
      },
      expression: "start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    style: _vm.v$.start_at.time.HH.$error || _vm.v$.start_at.time.mm.$error ? 'border: 1px solid red' : '',
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "hour-label": '時',
      "minute-label": '分',
      "input-class": ['form-control']
    },
    model: {
      value: _vm.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "time", $$v);
      },
      expression: "start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.time.HH.$error || !_vm.v$.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間",
      "label-for": "end_at"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.end_at.date.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "date", $$v);
      },
      expression: "end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    style: _vm.v$.end_at.time.HH.$error || _vm.v$.end_at.time.mm.$error ? 'border: 1px solid red' : '',
    attrs: {
      "format": "HH:mm",
      "placeholder": "選擇時間",
      "hour-label": '時',
      "minute-label": '分',
      "input-class": ['form-control']
    },
    model: {
      value: _vm.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "time", $$v);
      },
      expression: "end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.time.HH.$error || !_vm.v$.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.preorderSetting.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting, "is_enabled", $$v);
      },
      expression: "preorderSetting.is_enabled"
    }
  }, [_vm._v("啟用")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo"
    }
  }, [_c('AppFileUploader', {
    attrs: {
      "placeholder-when-uploaded": "（查看檔案）",
      "placeholder-when-empty": ""
    },
    model: {
      value: _vm.preorderSetting.config.logo.image,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "image", $$v);
      },
      expression: "preorderSetting.config.logo.image"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 對齊方式"
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.preorderSetting.config.logo.alignment,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "alignment", $$v);
      },
      expression: "preorderSetting.config.logo.alignment"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v("靠左")]), _c('b-form-radio', {
    attrs: {
      "value": "center"
    }
  }, [_vm._v("置中")]), _c('b-form-radio', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v("靠右")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 寬度"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.logo.width,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "width", $$v);
      },
      expression: "preorderSetting.config.logo.width"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 上方間距"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.logo.top_margin,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "top_margin", $$v);
      },
      expression: "preorderSetting.config.logo.top_margin"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 下方間距"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.logo.bottom_margin,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "bottom_margin", $$v);
      },
      expression: "preorderSetting.config.logo.bottom_margin"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 左邊間距"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.logo.left_margin,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "left_margin", $$v);
      },
      expression: "preorderSetting.config.logo.left_margin"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Logo 右邊間距"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.logo.right_margin,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.logo, "right_margin", $$v);
      },
      expression: "preorderSetting.config.logo.right_margin"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用搜尋"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.preorderSetting.config.product_page.enable_filters,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "enable_filters", $$v);
      },
      expression: "preorderSetting.config.product_page.enable_filters"
    }
  }, [_vm._v("是否啟用搜尋")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每頁商品數量"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: _vm.preorderSetting.config.product_page.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "per_page", $$v);
      },
      expression: "preorderSetting.config.product_page.per_page"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "庫存檢查"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '檢查',
        value: true
      }, {
        text: '不檢查',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.product_page.check_stock,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "check_stock", $$v);
      },
      expression: "preorderSetting.config.product_page.check_stock"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "無庫存項目"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '顯示',
        value: true
      }, {
        text: '不顯示',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.product_page.product_is_visible_when_out_of_stock,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "product_is_visible_when_out_of_stock", $$v);
      },
      expression: "preorderSetting.config.product_page.product_is_visible_when_out_of_stock"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示明細"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '顯示',
        value: true
      }, {
        text: '不顯示',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.product_page.display_detail,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "display_detail", $$v);
      },
      expression: "preorderSetting.config.product_page.display_detail"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示金額(前台尚未實作)"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '顯示',
        value: true
      }, {
        text: '不顯示',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.product_page.display_price,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "display_price", $$v);
      },
      expression: "preorderSetting.config.product_page.display_price"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "收費模式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '預購模式',
        value: null
      }, {
        text: '金額模式',
        value: 'money'
      }, {
        text: '點數模式',
        value: 'point'
      }]
    },
    model: {
      value: _vm.preorderSetting.charge_mode,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting, "charge_mode", $$v);
      },
      expression: "preorderSetting.charge_mode"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示會員點數"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '是',
        value: true
      }, {
        text: '否',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.point_mode.show_point,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.point_mode, "show_point", $$v);
      },
      expression: "preorderSetting.config.point_mode.show_point"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員點數提示文字"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.point_mode.text_before_remaining_point,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.point_mode, "text_before_remaining_point", $$v);
      },
      expression: "preorderSetting.config.point_mode.text_before_remaining_point"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否自動扣點"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '是(尚不提供）',
        value: true,
        disabled: true
      }, {
        text: '否',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.point_mode.automatic_point_deduction,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.point_mode, "automatic_point_deduction", $$v);
      },
      expression: "preorderSetting.config.point_mode.automatic_point_deduction"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否不能超過點數"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '是',
        value: true
      }, {
        text: '否',
        value: false
      }]
    },
    model: {
      value: _vm.preorderSetting.config.point_mode.point_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.point_mode, "point_limit", $$v);
      },
      expression: "preorderSetting.config.point_mode.point_limit"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預購單數量限制"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "name": "status_limit",
      "value": false
    },
    model: {
      value: _vm.preorderSetting.config.status_limit.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.status_limit, "enabled", $$v);
      },
      expression: "preorderSetting.config.status_limit.enabled"
    }
  }, [_vm._v("不限制")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "status_limit",
      "value": true
    },
    model: {
      value: _vm.preorderSetting.config.status_limit.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.status_limit, "enabled", $$v);
      },
      expression: "preorderSetting.config.status_limit.enabled"
    }
  }, [_vm._v(" 同時間只能有 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.preorderSetting.config.status_limit.maximum,
      expression: "preorderSetting.config.status_limit.maximum"
    }],
    staticStyle: {
      "width": "64px",
      "border": "1px solid #aaa"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.preorderSetting.config.status_limit.maximum
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preorderSetting.config.status_limit, "maximum", $event.target.value);
      }
    }
  }), _vm._v(" 張 ")]), _c('JsonEditor', {
    staticClass: "ml-3",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "lines": 3
    },
    model: {
      value: _vm.preorderSetting.config.status_limit.statuses,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.status_limit, "statuses", $$v);
      },
      expression: "preorderSetting.config.status_limit.statuses"
    }
  }), _c('b-input', {
    staticClass: "ml-3",
    staticStyle: {
      "max-width": "240px"
    },
    model: {
      value: _vm.preorderSetting.config.status_limit.warning,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.status_limit, "warning", $$v);
      },
      expression: "preorderSetting.config.status_limit.warning"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "填寫權限"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.permissionOptions
    },
    model: {
      value: _vm.preorderSetting.config.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config, "permissions", $$v);
      },
      expression: "preorderSetting.config.permissions"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#fields' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', [_vm.preorderSetting.id ? _c('DynamicFormEditor', {
    attrs: {
      "editor-title": "預約單欄位編輯",
      "form-type": "preorder",
      "input-subjects": _vm.preorderSetting.config.fields
    },
    on: {
      "output": _vm.saveFields
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm.step == '#product-setting' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v("商品設定")])]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-search-product",
      modifiers: {
        "modal-search-product": true
      }
    }],
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.showLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("選擇商品")])], 1), _c('PreorderSettingProductSelect', {
    attrs: {
      "selected-products": _vm.selectedProducts
    },
    on: {
      "selected": _vm.handleUpdateSelectedProducts
    }
  }), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.products,
      "fields": _vm.productFields
    },
    scopedSlots: _vm._u([{
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProductDetail',
              params: {
                product_id: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'title')))]), _c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'sale_page_code')))])])];
      }
    }, {
      key: "cell(image)",
      fn: function fn(data) {
        return [_vm.deepGet(data.item, 'images[0].pic_url') ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": _vm.deepGet(data.item, 'images[0].pic_url'),
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteProduct(data.item, data);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")])];
      }
    }], null, false, 1565554508)
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#welcome' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v("歡迎頁")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "歡迎頁面頁面說明"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.preorderSetting.config.welcome_page.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.welcome_page, "terms", $$v);
      },
      expression: "preorderSetting.config.welcome_page.terms"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "歡迎頁面同意文字"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.welcome_page.hint_for_consent,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.welcome_page, "hint_for_consent", $$v);
      },
      expression: "preorderSetting.config.welcome_page.hint_for_consent"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "歡迎頁面按鈕文字"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.welcome_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.welcome_page, "button_text", $$v);
      },
      expression: "preorderSetting.config.welcome_page.button_text"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店選單圖片(上方)"
    }
  }, [_c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event, 'welcome_page.top_image_url');
      }
    }
  }), !!_vm.preorderSetting.config['welcome_page']['top_image_url'] ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    on: {
      "click": function click($event) {
        _vm.preorderSetting.config['welcome_page']['top_image_url'] = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.preorderSetting.config['welcome_page'] ? _vm.preorderSetting.config['welcome_page']['top_image_url'] : null,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" 目前路徑：" + _vm._s(_vm.preorderSetting.config['welcome_page']['top_image_url'] || '未上傳') + " ")])])], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店選單圖片(下方)"
    }
  }, [_c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event, 'welcome_page.bottom_image_url');
      }
    }
  }), !!_vm.preorderSetting.config['welcome_page']['bottom_image_url'] ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    on: {
      "click": function click($event) {
        _vm.preorderSetting.config['welcome_page']['bottom_image_url'] = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.preorderSetting.config['welcome_page'] ? _vm.preorderSetting.config['welcome_page']['bottom_image_url'] : null,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" 目前路徑：" + _vm._s(_vm.preorderSetting.config['welcome_page']['bottom_image_url'] || '未上傳') + " ")])])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#confirm' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v("確認頁")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "確認頁面頁面說明"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.preorderSetting.config.confirm_page.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.confirm_page, "terms", $$v);
      },
      expression: "preorderSetting.config.confirm_page.terms"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店選單圖片(上方)"
    }
  }, [_c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event, 'confirm_page.top_image_url');
      }
    }
  }), !!_vm.preorderSetting.config['confirm_page']['top_image_url'] ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    on: {
      "click": function click($event) {
        _vm.preorderSetting.config['confirm_page']['top_image_url'] = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.preorderSetting.config['confirm_page'] ? _vm.preorderSetting.config['confirm_page']['top_image_url'] : null,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" 目前路徑：" + _vm._s(_vm.preorderSetting.config['confirm_page']['top_image_url'] || '未上傳') + " ")])])], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店選單圖片(下方)"
    }
  }, [_c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event, 'confirm_page.bottom_image_url');
      }
    }
  }), !!_vm.preorderSetting.config['confirm_page']['bottom_image_url'] ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    on: {
      "click": function click($event) {
        _vm.preorderSetting.config['confirm_page']['bottom_image_url'] = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.preorderSetting.config['confirm_page'] ? _vm.preorderSetting.config['confirm_page']['bottom_image_url'] : null,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" 目前路徑：" + _vm._s(_vm.preorderSetting.config['confirm_page']['bottom_image_url'] || '未上傳') + " ")])])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#finish' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v("完成頁")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面標題"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.finish_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "form_title", $$v);
      },
      expression: "preorderSetting.config.finish_page.form_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面副標題"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.finish_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "form_desc", $$v);
      },
      expression: "preorderSetting.config.finish_page.form_desc"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面敘述"
    }
  }, [_c('TrixEditor', {
    model: {
      value: _vm.preorderSetting.config.finish_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "content", $$v);
      },
      expression: "preorderSetting.config.finish_page.content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面按鈕文字"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.finish_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "button_text", $$v);
      },
      expression: "preorderSetting.config.finish_page.button_text"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面按鈕超連結"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.finish_page.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "button_url", $$v);
      },
      expression: "preorderSetting.config.finish_page.button_url"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束頁面按鈕動作"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.finish_page.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.finish_page, "button_action", $$v);
      },
      expression: "preorderSetting.config.finish_page.button_action"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#advance-setting' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預購單活動名稱',
      "name": _vm.preorderSetting.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v("進階設定")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品來源"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '分店',
        value: true
      }, {
        text: '無隸屬分店',
        value: false
      }]
    },
    on: {
      "input": _vm.handleShouldFilterProductByBranchChanged
    },
    model: {
      value: _vm.preorderSetting.config.product_page.should_filter_product_by_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.product_page, "should_filter_product_by_branch", $$v);
      },
      expression: "preorderSetting.config.product_page.should_filter_product_by_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用分店選單",
      "label-for": "branch_select_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "branch_select_enabled",
      "name": "branch_select_enabled",
      "value": true,
      "unchecked-value": false,
      "disabled": true === _vm.preorderSetting.config.product_page.should_filter_product_by_branch
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "is_enabled", $$v);
      },
      expression: "preorderSetting.config.branch_select.is_enabled"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店顯示類型 *"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "input-group",
    attrs: {
      "options": [{
        text: '所有分店',
        value: 'all'
      }, {
        text: '自訂分店',
        value: 'subset'
      }]
    },
    on: {
      "input": function input($event) {
        return _vm.loadSelectedBranch(_vm.preorderSetting.config.branch_select);
      }
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.branch_population,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "branch_population", $$v);
      },
      expression: "preorderSetting.config.branch_select.branch_population"
    }
  })], 1), _vm.preorderSetting.config.branch_select.branch_population === 'all' ? [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店下拉選單來源"
    }
  }, [_c('BranchProviderEditor', {
    ref: "branch-provider-editor",
    attrs: {
      "showBranchCode": _vm.preorderSetting.config.branch_select.show_branch_code
    },
    on: {
      "update:showBranchCode": function updateShowBranchCode($event) {
        return _vm.$set(_vm.preorderSetting.config.branch_select, "show_branch_code", $event);
      },
      "update:show-branch-code": function updateShowBranchCode($event) {
        return _vm.$set(_vm.preorderSetting.config.branch_select, "show_branch_code", $event);
      },
      "mounted": function mounted($event) {
        return _vm.loadSelectedBranch(_vm.preorderSetting.config.branch_select);
      },
      "input": function input($event) {
        return _vm.handleShopSelectionProviderChange(_vm.preorderSetting.config.branch_select);
      }
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.branch_provider,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "branch_provider", $$v);
      },
      expression: "preorderSetting.config.branch_select.branch_provider"
    }
  })], 1)] : _vm.preorderSetting.config.branch_select.branch_population === 'subset' ? [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "自訂分店"
    }
  }, [_c('BranchSubsetEditor', {
    attrs: {
      "showBranchCode": _vm.preorderSetting.config.branch_select.show_branch_code
    },
    on: {
      "update:showBranchCode": function updateShowBranchCode($event) {
        return _vm.$set(_vm.preorderSetting.config.branch_select, "show_branch_code", $event);
      },
      "update:show-branch-code": function updateShowBranchCode($event) {
        return _vm.$set(_vm.preorderSetting.config.branch_select, "show_branch_code", $event);
      }
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.branch_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "branch_ids", $$v);
      },
      expression: "preorderSetting.config.branch_select.branch_ids"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示上層分店下拉"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.show_parent_branch_options,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "show_parent_branch_options", $$v);
      },
      expression: "preorderSetting.config.branch_select.show_parent_branch_options"
    }
  })], 1)] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店下拉選單文字"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.default_select_text,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "default_select_text", $$v);
      },
      expression: "preorderSetting.config.branch_select.default_select_text"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示分店代號"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.preorderSetting.config.branch_select.show_branch_code,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.branch_select, "show_branch_code", $$v);
      },
      expression: "preorderSetting.config.branch_select.show_branch_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態參數"
    }
  }, [_c('editor', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "width": "100%",
      "height": "200px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.statusInput,
      callback: function callback($$v) {
        _vm.statusInput = $$v;
      },
      expression: "statusInput"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "填寫後貼標"
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.preorderSetting.config.finish_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config, "finish_tags", $$v);
      },
      expression: "preorderSetting.config.finish_tags"
    }
  })], 1), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12"
  }, [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.preorderSetting.name
    }
  })], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 推播範本 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "表頭背景色"
    }
  }, [_c('color-picker', {
    model: {
      value: _vm.preorderSetting.config.push_template.header_bg_color,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.push_template, "header_bg_color", $$v);
      },
      expression: "preorderSetting.config.push_template.header_bg_color"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕背景色"
    }
  }, [_c('color-picker', {
    model: {
      value: _vm.preorderSetting.config.push_template.button_bg_color,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.push_template, "button_bg_color", $$v);
      },
      expression: "preorderSetting.config.push_template.button_bg_color"
    }
  })], 1)], 1), _c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" 填寫後推播 ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.preorderSetting.config.push_template.created_push_message,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.push_template, "created_push_message", $$v);
      },
      expression: "preorderSetting.config.push_template.created_push_message"
    }
  }, [_vm._v("啟用填寫後立即推播")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 表頭圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.preorderSetting.config.push_template.created_push_header_image_url,
            callback: function callback($$v) {
              _vm.$set(_vm.preorderSetting.config.push_template, "created_push_header_image_url", $$v);
            },
            expression: "preorderSetting.config.push_template.created_push_header_image_url"
          }
        })];
      },
      proxy: true
    }], null, false, 159631053)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "推播文字"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.preorderSetting.config.push_template.created_push_message_content,
      callback: function callback($$v) {
        _vm.$set(_vm.preorderSetting.config.push_template, "created_push_message_content", $$v);
      },
      expression: "preorderSetting.config.push_template.created_push_message_content"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 2) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }